import React from 'react';

const ContactCTA = () => {
  return (
    <section className="bg-accent-dark py-48 px-24 mt-8" id="contact">
      <div className="mx-auto text-center" style={{ maxWidth: 640 }}>
        <h2 className="text-white text-42px mb-24">Get in Touch</h2>
        <p className="text-white mb-32">
          If you are an investor, a potential B2B partner for SmartCabin, or a strategic partner interested in systems architecture, I'd love to connect.
        </p>
        <a href="mailto:teman@beckdevelops.com">
          <button className="px-48 py-18 mt-8 mb-8 primary-color-dark no-border bold br-5 nav-button">
            Contact Teman Beck
          </button>
        </a>
      </div>
    </section>
  );
};

export default ContactCTA;

